import { FC } from 'react';
import { Tooltip } from 'antd';
import { IoIosInformationCircleOutline } from 'react-icons/io';
import { BillableHoursData } from './overview.model';
import styles from './overview.module.less';

interface ChartRowProps {
  name: string;
  percent: number;
}

const ChartRow: FC<ChartRowProps> = ({ name, percent }) => {
  const billableWidth = Math.max(0, Math.min(100, percent));
  const nonBillableWidth = 100 - billableWidth;

  return (
    <div className={styles.chart}>
      <div className={styles.chartTop}>
        <span className={styles.chartName}>{name}</span>
        <span className={styles.chartPercent}>{Math.round(percent)}%</span>
      </div>
      <div className={styles.progressTrack}>
        <div className={styles.progressBillable} style={{ width: `${billableWidth}%` }} />
        <div className={styles.progressNonBillable} style={{ width: `${nonBillableWidth}%` }} />
      </div>
    </div>
  );
};

interface BillableHoursProps {
  data: BillableHoursData;
}

const BillableHours: FC<BillableHoursProps> = ({ data }) => {
  const { teamAveragePercent, youPercent, lastPeriodBillablePercent } = data;

  return (
    <div className={`${styles.card} ${styles.billableCard}`}>
      <div className={styles.cardHeader}>Billable hours</div>

      <div className={styles.charts}>
        <ChartRow name="Team average" percent={teamAveragePercent} />
        <ChartRow name="Your" percent={youPercent} />

        <div className={styles.legendRow}>
          <span className={styles.legendItem}>
            <span className={styles.legendSwatch} style={{ background: '#0044cc' }} />
            <span className={styles.legendLabel}>Billable</span>
          </span>
          <span className={styles.legendItem}>
            <span className={styles.legendSwatch} style={{ background: '#ccd2df' }} />
            <span className={styles.legendLabel}>Non-billable</span>
          </span>
        </div>
      </div>

      <div className={styles.divider} />
      <div className={styles.lastPeriod}>
        <span>
          Last period <b>{Math.round(lastPeriodBillablePercent)}%</b> billable
        </span>
        <Tooltip title="Share of your hours that were billable in the previous period.">
          <span className={styles.infoIconWrap}>
            <IoIosInformationCircleOutline className={styles.infoIcon} />
          </span>
        </Tooltip>
      </div>
    </div>
  );
};

export default BillableHours;
